<span class='variation-line'>
  {#each moveListNodes as moveListNode, i}
    {#if moveListNode.beforeComment !== undefined && !$commentsHidden}
      <Comment
        comment={{ node: moveListNode.node, comment: moveListNode.beforeComment, isBeforeComment: true }}
      />
    {/if}
    <span class='inline-move'>
      {#if i === 0 || isWhite(moveListNode)}
        <span class={`move-number ${i === 0 && 'start'}`}>
          {getWholeMoveNumber(moveListNode.node, $startingMoveNumber)}{isWhite(moveListNode) ? '.' : '...'}
        </span>
      {/if}

      <Ply
        node={moveListNode.node}
        disableAllIcons={true}
      />
    </span>

    {#if moveListNode.afterComment !== undefined && !$commentsHidden}
      <Comment
        comment={{ node: moveListNode.node, comment: moveListNode.afterComment }}
      />
    {/if}

    {#if moveListNode.inlineVariations}
      {#each moveListNode.inlineVariations as inlineVariation}
        <i>
          <span class="inline-variation-paren">(</span>
          <svelte:self moveListNodes={inlineVariation} />
          <span class="inline-variation-paren">)</span>
        </i>
      {/each}
    {/if}
  {/each}
</span>

<script lang="ts">
import type { MoveListComponent } from 'components/move-list/config/types';
import { Game } from 'chessboard/model/game/types';
import { getWholeMoveNumber } from 'components/move-list/helpers/move-list-node-utils';
import Comment from 'components/move-list/components/comment.svelte';
import Ply from 'components/move-list/components/ply.svelte';
import type { ContextShape } from 'components/move-list/store/types';
import { getContext } from 'svelte';
import { MoveListPlugin } from 'chessboard/plugins/move-list/config/types';

export let moveListNodes: MoveListComponent.MoveListNode[];

const { store } = getContext<ContextShape>(MoveListPlugin.Name);
const { commentsHidden, startingMoveNumber } = store;

/**
 * determines if the move list node is a white move
 */
function isWhite(moveListNode: MoveListComponent.MoveListNode) {
  return moveListNode.node.color === Game.ColorsAsNumbers.White;
}
</script>
